import * as React from 'react'
import { MouseParallaxContainer, MouseParallaxChild } from 'react-parallax-mouse'

import { Content } from 'sdk/components'
import { Text, TextName } from 'sdk'
import { Button } from 'sdk/button/Button'
import underglow from 'shared/assets/underglow.png'
import grid from 'shared/assets/grid.png'

import { SectionId } from 'core/interfaces'
import type { SoundcoreFlagshipProductCmsContent } from 'core/services/cms/interfaces'

import trombone from './assets/trombone.png'
import violin from './assets/violin.png'
import clarinet from './assets/clarinet.png'
import laptop from './assets/laptop.png'

import classes from './style.module.scss'


interface FlagshipProductProps {
  content: SoundcoreFlagshipProductCmsContent
}

export const FlagshipProduct: React.FC<FlagshipProductProps> = ({ content }) => {
  return (
    <Content id={SectionId.FlagshipProduct} className={classes.content}>
      <img className={classes.grid} src={grid} alt='grid' />

      <MouseParallaxContainer
        globalFactorX={0.015}
        globalFactorY={0.015}
        resetOnLeave
        useWindowMouseEvents
        containerStyle={{ overflow: 'visible' }}
        className={classes.productContainer}
      >
        <img className={classes.glow} src={underglow} alt='underglow' />

        <img className={classes.laptop} src={laptop} width={1036} height={694} alt='mac' />

        <Text type={TextName.H2} className={classes.subtitle}>
          {content.subtitle}
        </Text>

        <Text className={classes.title} type={TextName.SuperBigText}>
          {content.titleText}
        </Text>

        <MouseParallaxChild factorX={1.5} factorY={1.5} className={classes.trombone}>
          <img src={trombone} width={866} height={358} alt='violin' />
        </MouseParallaxChild>

        <MouseParallaxChild className={classes.violin}>
          <img src={violin} width={450} height={292} alt='violin' />
        </MouseParallaxChild>

        <MouseParallaxChild factorX={2.4} factorY={2.4} className={classes.clarinet}>
          <img src={clarinet} width={680} height={314} alt='clarinet' />
        </MouseParallaxChild>
      </MouseParallaxContainer>

      <Text type={TextName.Text} className={classes.text}>
        {content.description}
      </Text>

      <Button
        href={content.buttonUrl}
        as='link'
        target='_blank'
        className={classes.actionButton}
      >
        {content.buttonText}
      </Button>
    </Content>
  )
}
